import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

export const getTicketsData = params =>
  axios.get(`${API_HOST}/shashoku/tickets`, { params, withCredentials: true });

export const getTicketsUsedByAdminData = params =>
  axios.get(`${API_HOST}/shashoku/tickets-used-by-admin`, {
    params,
    withCredentials: true
  });

export const postTicketsUsedByAdminData = params =>
  axios.post(`${API_HOST}/shashoku/tickets-used-by-admin`, params, {
    withCredentials: true
  });

export const downloadTicketsData = params =>
  axios.get(`${API_HOST}/shashoku/tickets/download`, {
    params,
    withCredentials: true
  });

export const downloadTicketsUsedByAdminData = params =>
  axios.get(`${API_HOST}/shashoku/tickets-used-by-admin/download`, {
    params,
    withCredentials: true
  });

export const updateTicketsStatusData = params =>
  axios.post(`${API_HOST}/shashoku-tickets/recycle`, params, {
    withCredentials: true
  });

export const getTicketRefundData = params =>
  axios.get(`${API_HOST}/shashoku/refund`, {
    params,
    withCredentials: true
  });

export const refundExtraPayTicketBizmeshiData = params =>
  axios.post(`${API_HOST}/shashoku/refund`, params, {
    withCredentials: true
  });

export default getTicketsData;
